import { useMemo } from "react";
import { OcRoleFilterItemData } from "oc/components/role-filter";
import { RoleFilterInput } from "oc/types";

interface UseOcRoleFilterSubtypeHeaderProps {
  type: keyof RoleFilterInput;
  selectedItems: OcRoleFilterItemData[];
}

const labels: Record<keyof RoleFilterInput, string> = {
  company: "OC_COMPANY",
  orgUnit: "OC_ORGUNIT",
  workingPlace: "OC_WORKINGPLACE",
  jobClassGroup: "OC_JOBCLASSGROUP",
  payOffice: "OC_PAYOFFICE",
  contract: "OC_GET_EMPLOYEE",
};

const icons: Record<keyof RoleFilterInput, string> = {
  company: "mdi:city",
  orgUnit: "mdi:sitemap",
  workingPlace: "mdi:home-account",
  jobClassGroup: "mdi:account-box-multiple",
  payOffice: "mdi:credit-card-marker-outline",
  contract: "mdi:account",
};

export const useOcRoleFilterSubtypeHeader = ({
  type,
  selectedItems,
}: UseOcRoleFilterSubtypeHeaderProps) => {
  const icon = icons[type];
  const title = labels[type];

  const subTitle = useMemo(() => {
    const labelsArray = selectedItems.map((item) => item.name);

    return labelsArray.join(", ");
  }, [selectedItems]);

  const selectedItemsCount = selectedItems.length;

  return {
    icon,
    title,
    subTitle,
    selectedItemsCount,
  };
};
